export const REVIEW_SECTIONS = ['Treatment', 'Subjective', 'Objective', 'Assessment', 'Plan'];
// The summarizer's label for nonclinical speech (which also gets an empty
// summary). Accepted from the API, never shown as a section.
export const NONCLINICAL_SECTION = 'Other / unclear';

// Metadata only: the source records remain the authority for correction actions.
export async function summarizeReview(apiClient, lines, onBatch) {
  if (!apiClient?.summarizeMultiRecordReview) return;
  const batches = [];
  let batch = [];
  let chars = 0;
  [...lines].sort((a, b) => a.spokenAt - b.spokenAt || a.seq - b.seq).forEach((line) => {
    if (line.text.length > 24000) return; // Keep the original wording for oversized lines.
    if (batch.length === 60 || chars + line.text.length > 24000) {
      batches.push(batch);
      batch = [];
      chars = 0;
    }
    batch.push({
      id: line.id, text: line.text,
      ...(line.candidates ? {
        candidates: line.candidates.map((id) => ({ id: String(id), name: line.names?.[id] || `Visit ${id}` })),
        owner: line.from == null ? null : String(line.from),
      } : {}),
    });
    chars += line.text.length;
  });
  if (batch.length) batches.push(batch);
  for (const sources of batches) {
    try {
      const data = await apiClient.summarizeMultiRecordReview(sources);
      const allowed = new Set(sources.map((line) => line.id));
      const summaries = {};
      (Array.isArray(data?.summaries) ? data.summaries : []).forEach((item) => {
        if (
          allowed.has(item?.sourceId) && !summaries[item.sourceId] &&
          typeof item.summary === 'string' &&
          [...REVIEW_SECTIONS, NONCLINICAL_SECTION].includes(item.section)
        ) {
          summaries[item.sourceId] = {
            summary: item.summary.trim(), section: item.section, sourceIds: [item.sourceId],
          };
          const source = lines.find((line) => line.id === item.sourceId);
          const guess = Number(item.bestGuess);
          if (
            item.bestGuess != null && source.candidates?.includes(guess) &&
            ['confident', 'needs_review', 'unplaced'].includes(item.confidence)
          ) {
            summaries[item.sourceId].bestGuess = source.from == null ? guess : source.from;
            summaries[item.sourceId].confidence = source.from != null && item.confidence === 'unplaced'
              ? 'needs_review' : source.from == null && item.confidence === 'confident' ? 'needs_review' : item.confidence;
          }
        }
      });
      if (onBatch(summaries) === false) return;
    } catch (error) {
      // A review must remain usable when the optional summary request fails.
      console.warn('[MultiRecorder] review summaries unavailable', error);
      if (onBatch({}) === false) return;
    }
  }
}
